export default {"src":"https://fishbrain.com/_next/static/media/new_moon.438f95dd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};